module.exports = __webpack_public_path__ + "static/img/xjt.bd28d17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/xjt.png
// module id = aJeB
// module chunks = 1